import TabPage from "../components/common/template/tabs/TabPage"
import TabToolbarButton from "../components/common/template/tabs/TabToolbarButton"

export default {
  components: {
    TabPage,
    TabToolbarButton,
  },
  props: {
    index: { type: Number, required: true },
    tab: { type: Object, required: true },
    tabs: { type: Array, required: true },
  },
  data: () => ({
    pages: [],
    page: "",
  }),
  methods: {
    showHelp(menu,page) {
      //-- return an event to Ack the job is done
      document.dispatchEvent(
          new CustomEvent("show-help", { detail: {
              documentationPath: "manager/" + menu + "/" + page + "/page"
            }
          })
      )
      console.log('menu',menu)
      console.log('page',page)
    },
    // Generate an uuid with a specified mask.
    uuid() {
      let dt = new Date().getTime()
      return "xxxxxxxxxx".replace(/[xy]/g, function(c) {
        let r = (dt + Math.random() * 16) % 16 | 0
        dt = Math.floor(dt / 16)
        return (c === "x" ? r : (r & 0x3) | 0x8).toString(16)
      })
    },
    // Clean a vue object to normal object
    clean(obj) {
      return JSON.parse(JSON.stringify(obj))
    },
    // Commit prop changes
    commit(payload) {
      this.$emit("update", payload)
    },
    // Test if tab is locked
    locked(tab) {
      return tab.hasOwnProperty("locked") && tab.locked === true
    },
    // Test if tab is in tabs
    exist(tab) {
      return this.tabs.some(e => e.name === tab.name)
    },
    // Return existing tab by name
    retrieve(tab) {
      return this.clean(this.tabs.find(e => e.name === tab.name))
    },
    // Test if tab is in tabs by uuid
    existByUuid(tab) {
      return this.tabs.some(e => e.uuid === tab.uuid)
    },
    // Return existing tab by uuid
    retrieveByUuid(tab) {
      return this.clean(this.tabs.find(e => e.uuid === tab.uuid))
    },
    // Test if tab is a singleton
    isSingleton(tab) {
      return tab.hasOwnProperty("singleton") && tab.singleton === true
    },
    // Open tab
    open(tab) {
      if (this.exist(tab)) {
        let newIndex = this.tabs.findIndex(e => e.uuid === tab.uuid)
        if (!isNaN(newIndex)) {
          this.commit({ prop: "index", value: newIndex })
        }
      }
    },
    // Push a new tab
    push(configuration) {
      // Clean the configuration to remove the observer
      configuration = this.clean(configuration)

      // Test if singleton mode is enabled
      if (this.isSingleton(configuration)) {
        // If tab already exist we open it
        if (this.exist(configuration)) {
          let prev = this.retrieve(configuration)
          this.open(prev)
          return
        }
      }

      // Generate an uuid for the new tab
      configuration.uuid = this.uuid()

      // Merge all tabs
      let mergedTabs = this.tabs
      mergedTabs.push(configuration)

      // Commit changes
      this.commit({ prop: "tabs", value: mergedTabs })

      // Open the new tab
      this.open(configuration)
    },
    // Remove tab by uuid
    remove(uuid) {
      if (!this.existByUuid({ uuid })) return

      let configuration = this.retrieveByUuid({ uuid })

      if (this.locked(configuration)) return

      // Making sub array with not removed tabs
      let restTabs
      restTabs = this.tabs.filter(e => e.uuid !== configuration.uuid)

      // Change index (current tab)
      if (
        this.tabs[this.index] &&
        this.tabs[this.index].hasOwnProperty("uuid") &&
        uuid === this.tabs[this.index].uuid
      ) {
        let newIndex = this.index > 0 ? this.index - 1 : 0
        this.commit({ prop: "index", value: newIndex })
      } else {
        let deletedIndex = this.tabs.findIndex(e => e.uuid === uuid)
        if (deletedIndex < this.index) {
          let newIndex = this.index > 0 ? this.index - 1 : 0
          this.commit({ prop: "index", value: newIndex })
        }
      }

      // Commit changes
      this.commit({ prop: "tabs", value: restTabs })
    },
    // Remove the current tab
    removeCurrent() {
      // TODO this code seams to never be used
      if (this.locked(this.tab)) return

      // Making sub array with not removed tabs
      let restTabs
      restTabs = this.tabs.filter(e => e.uuid !== this.tab.uuid)

      // Change index to open the closest tab
      let newIndex = this.index > 0 ? this.index - 1 : 0
      this.commit({ prop: "index", value: newIndex })

      // Commit tabs changes
      this.commit({ prop: "tabs", value: restTabs })
    },
    // Remove all tabs by name
    removeAll(configuration) {
      if (this.locked(configuration)) return

      // Making sub array with not removed tabs
      let restTabs = this.tabs.filter(e => e.name !== configuration.name)

      // Commit changes
      this.commit({ prop: "tabs", value: restTabs })
    },
    reloadPreviousOpenedTab() {
      //-- Setup the previous opened Tab Page
      const pageAlreadyOpened = this.$ls.get(`tab.${this.menu}`)
      if (pageAlreadyOpened) {
        this.page = pageAlreadyOpened
      }
    },
  },
}
